var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "camere-selector" }, [
    _c("input", {
      attrs: { placeholder: _vm.placeholder, readonly: "" },
      domProps: { value: _vm.summaryText },
      on: { click: _vm.onShowClose }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show"
          }
        ],
        staticClass: "popup"
      },
      [
        _c(
          "div",
          { staticClass: "items" },
          [
            _vm._l(_vm.camere, function(item, index) {
              return _c("CamereSelectorItem", {
                key: index,
                attrs: {
                  title: "Camera " + (index + 1),
                  index: index,
                  value: item
                },
                on: { change: _vm.onChangeCamera }
              })
            }),
            _vm._v(" "),
            _c("div", { staticClass: "text-center mt-2 py-2" }, [
              _vm.camere.length < 4
                ? _c(
                    "a",
                    {
                      staticClass:
                        "btn btn-success py-1 btn-sm mb-2 text-uppercase",
                      attrs: { href: "javascript:void(0)" },
                      on: { click: _vm.onAddCamera }
                    },
                    [_vm._v("Aggiungi")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.camere.length > 1
                ? _c(
                    "a",
                    {
                      staticClass:
                        "btn btn-sm py-1 btn-danger mb-2 text-uppercase",
                      attrs: { href: "javascript:void(0)" },
                      on: { click: _vm.onRemoveCamera }
                    },
                    [_vm._v("\n                    Rimuovi\n                ")]
                  )
                : _vm._e()
            ])
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "text-center" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-sm py-1 px-5",
              attrs: { type: "button" },
              on: { click: _vm.onConfirm }
            },
            [_vm._v("Conferma")]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-695631dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-695631dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/CamereSelector.vue
// module id = null
// module chunks = 